/** @format */

import {AiReportGoal, Campaign, CampaignMediaplanStat, MetricGoal} from '../types';

/**
 * Фильтрует и трансформирует данные кампаний на основе campaignIds из отчёта
 * @param campaignMediaplanStats - Полный список кампаний из GetCurrentUser
 * @param campaignIds - Массив ID кампаний, использованных в текущем отчёте
 * @returns Отфильтрованный массив кампаний для таблицы
 */
export const transformCampaignsData = (
  campaignMediaplanStats: readonly CampaignMediaplanStat[],
  campaignIds: readonly string[],
): Campaign[] => {
  if (!campaignMediaplanStats || !campaignIds || campaignIds.length === 0) {
    return [];
  }

  // Нормализуем campaignIds к строкам для корректного сравнения
  const normalizedCampaignIds = campaignIds.map(id => String(id));

  // Фильтруем кампании, оставляя только те, что есть в campaignIds
  const filteredCampaigns = campaignMediaplanStats.filter(campaign =>
    normalizedCampaignIds.includes(String(campaign.campaignId)),
  );

  // Трансформируем в формат для таблицы
  return filteredCampaigns.map(campaign => ({
    id: campaign.campaignId,
    name: campaign.campaignName,
    accountName: campaign.accountName,
  }));
};

/**
 * Трансформирует сохранённые цели из БД в формат для таблицы
 * Бэкенд гарантирует заполнение goals через lazy migration
 */
export const transformGoalsData = (
  storedGoals: readonly AiReportGoal[] | null | undefined,
): MetricGoal[] => {
  if (!storedGoals || storedGoals.length === 0) {
    return [];
  }

  return storedGoals.map(goal => ({
    metricId: goal.counterId,
    metricName: goal.counterName,
    goalId: goal.id,
    goalName: goal.name,
  }));
};
